import { Component, EventEmitter, Output } from '@angular/core';
import { Gruppe } from '../../models/gruppe';
import { StatistikService } from '../../statistik.service';

@Component({
    selector: 'app-statistik-options-grupper',
    templateUrl: './statistik-options-grupper.component.html',
    standalone: false
})
export class StatistikOptionsGrupperComponent {
    @Output() selectGruppe = new EventEmitter<number>();
    grupper$ = this.statistikService.getGrupper();
    selectedGruppe: string;

    constructor(
        private statistikService: StatistikService
    ) { }

    onSelectGruppe(gruppe: Gruppe) {
        this.selectedGruppe = gruppe?.gruppe;
        this.selectGruppe.emit(gruppe?.id);
    }
}
